// test2570
(2570 && 0);
